module.exports = __webpack_public_path__ + "img/1.05c81187.png";